import React, { useState } from 'react';
import { Loader2, DatabaseZap } from 'lucide-react';
import { toast } from 'sonner';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { previewSyncAPI } from '../lib/api';

const Section = ({ title, rows, render, testid }) => (
  <div data-testid={testid}>
    <p className="text-sm font-medium mb-1">{title}</p>
    <ul className="text-xs space-y-0.5 text-muted-foreground">{rows.map((r, i) => <li key={i}>{render(r)}</li>)}</ul>
  </div>
);

export const PreviewSyncCard = () => {
  const [plan, setPlan] = useState(null);
  const [busy, setBusy] = useState(false);
  const run = async (apply) => {
    if (apply && !window.confirm('¿Aplicar estos cambios en este portal? No se envía ningún aviso ni correo.')) return;
    setBusy(true);
    try {
      const r = apply ? await previewSyncAPI.apply() : await previewSyncAPI.preview();
      setPlan(r);
      if (apply) toast.success('Datos pasados');
    } catch (e) { toast.error(e.message); } finally { setBusy(false); }
  };
  return (
    <Card data-testid="preview-sync-card">
      <CardHeader>
        <CardTitle className="text-base flex items-center gap-2"><DatabaseZap className="w-4 h-4" />Datos del 3 de noviembre</CardTitle>
        <CardDescription>Pasa a este portal lo trabajado ese día en el entorno de pruebas: publicaciones de noviembre de Óptica Corella, bienvenida ya hecha, emails y webhooks de Ads. No avisa a nadie y se puede pulsar varias veces sin duplicar.</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex gap-2">
          <Button variant="outline" onClick={() => run(false)} disabled={busy} data-testid="preview-sync-review">{busy && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}Revisar qué cambia</Button>
          {plan && !plan.aplicado && <Button onClick={() => run(true)} disabled={busy} data-testid="preview-sync-apply">Aplicar</Button>}
        </div>
        {plan && (
          <div className="space-y-3" data-testid="preview-sync-result">
            {plan.aplicado && <p className="text-sm text-emerald-700" data-testid="preview-sync-done">Aplicado. Así ha quedado:</p>}
            <Section testid="preview-sync-posts" title={`Publicaciones (${plan.publicaciones.length})`} rows={plan.publicaciones} render={(r) => `${r.fecha} · ${r.titulo} — ${r.resultado}`} />
            <Section testid="preview-sync-tasks" title={`Tareas del equipo (${plan.tareas.length})`} rows={plan.tareas} render={(r) => `${r.titulo} — ${r.resultado}`} />
            <Section testid="preview-sync-clients" title={`Clientes (${plan.clientes.length})`} rows={plan.clientes} render={(r) => `${r.nombre}: ${r.cambios.join(', ')}`} />
          </div>
        )}
      </CardContent>
    </Card>
  );
};
